export const cards = [
  {
    title: "Premium car rental",
    description: "Ipsum dolor sit amet, consectetur adipiscing elit.",
    image: "./assets/card1.jpg",
    link: "#",
  },
  {
    title: "Sport car rental",
    description: "lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    image: "./assets/card2.jpg",
    link: "#",
  },
  {
    title: "Limousine rental",
    description: "lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    image: "./assets/card3.jpg",
    link: "#",
  },
  {
    title: "Safety & insurance",
    description: "lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    image: "./assets/card4.jpg",
    link: "#",
  },
  {
    title: "How to book a car",
    description: "lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    image: "./assets/card5.jpg",
    link: "#",
  },
];

export const states = [
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const services = [
  {
    title: "All inclusive pricing",
    description: "lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    image: "./assets/gal1.png",
  },
  {
    title: "No hidden charges",
    description: "lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    image: "./assets/gal1.png",
  },
  {
    title: "Leading suppliers worldwide",
    description: "lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    image: "./assets/gal1.png",
  },
  {
    title: "Lowest price guarantee",
    description: "lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    image: "./assets/gal1.png",
  },
];

export const vehicleCards = [
  {
    title: "KIA RIO",
    description: "300 km included per day",
    img: "./assets/kia_rio.PNG",
    price: "110",
    url: "#vehicles",
  },
  {
    title: "SUZUKI SWIFT (Auto & Manuel)",
    description: "300 km included per day",
    img: "./assets/suzuki_swift.PNG",
    price: "110",
    url: "#vehicles",
  },
  {
    title: "VOLSWAGEN POLO",
    description: "300 km included per day",
    img: "./assets/vw_polo.PNG",
    price: "110",
    url: "#vehicles",
  },
  {
    title: "VOLSWAGEN VIRTUS",
    description: "300 km included per day",
    img: "./assets/vw_virtus.PNG",
    price: "120",
    url: "#vehicles",
  },
  {
    title: "HYUNDAI I20",
    description: "300 km included per day",
    img: "./assets/hyundai_i20.jpg",
    price: "120",
    url: "#vehicles",
  },
  {
    title: "HYUNDAI I10 (Auto & Manuel)",
    description: "300 km included per day",
    img: "./assets/hyundai_i10.PNG",
    price: "100",
    url: "#vehicles",
  },
  {
    title: "KIA PICANTO (Auto & Manuel)",
    description: "300 km included per day",
    img: "./assets/kia_picanto.jpg",
    price: "100",
    url: "#vehicles",
  },
  {
    title: "TOYOTA RAV4 HYBRIDE (Auto)",
    description: "300 km included per day",
    img: "./assets/toyota_rav4.jpg",
    price: "300",
    url: "#vehicles",
  },
  ,
  {
    title: "RENAULT CLIO 5",
    description: "300 km included per day",
    img: "./assets/RENAULT_CLIO.png",
    price: "120",
    url: "#vehicles",
  },
];
